//JQUERY FUNCTION TO CHECK IF ITEM IS WITHIN THE WINDOW VIEWPORT, VISIBLE
function inViewport(top_padding, bottom_padding) {

    if( $(this).length == 0 ){
        return false;
    }

    top_padding     = (typeof top_padding == 'undefined') ? 0 : parseInt(top_padding);
    bottom_padding  = (typeof bottom_padding == 'undefined') ? 0 : parseInt(bottom_padding);

    //get the passed item's postion
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    //get the viewports positions
    var viewportTop = $(window).scrollTop() - top_padding;
    var viewportBottom = viewportTop + $(window).height() + bottom_padding;

    //will return true if item is within viewport, else will return false
    return elementBottom >= viewportTop && elementTop <= viewportBottom
};

//RETURNS TRUE OR FALSE IF WINDOW SIZE IS TABLET 
function isTablet(){
    var width = $(window).width();
    return  width >= 768 && width <= 1024;
}

//RETURNS TRUE OR FALSE IF WINDOW SIZE IS MOBILE - use $().isMobile();
function isMobile(){
    return $(window).width() < 768;
}

export default {
    inViewport,
    isTablet,
    isMobile,
};